import { render } from "./Integrations.vue?vue&type=template&id=1ac60a6c"
import script from "./Integrations.vue?vue&type=script&lang=js"
export * from "./Integrations.vue?vue&type=script&lang=js"
script.render = render

export default script